(function () {
  'use strict';

  function PesosEventos() {
    return {
      templateUrl: `configuracoes/eventos/subpaginas/pesos/pesos-eventos.tpl.html`,
      controller: 'PesosEventosCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular
    .module('SubpaginasEventos')
    .directive('pesosEventos', PesosEventos);
}());
